"use strict";
/**
 * Chart-of-accounts type matching for Handshake mapping slots.
 * Xero and QuickBooks use different type strings for the same kind of account.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAccountingContractLiabilityAccountType = isAccountingContractLiabilityAccountType;
function compactAccountingAccountType(type) {
    return (type ?? "").trim().toUpperCase().replace(/[_-\s]+/g, "");
}
/** Xero LIABILITY / CURRLIAB / TERMLIAB and QBO Other Current / Long Term Liability. */
const CONTRACT_LIABILITY_ACCOUNT_TYPES = new Set([
    "LIABILITY",
    "CURRLIAB",
    "TERMLIAB",
    "CURRENTLIABILITY",
    "OTHERCURRENTLIABILITY",
    "OTHERCURRENTLIABILITIES",
    "LONGTERMLIABILITY",
    "LONGTERMLIABILITIES",
]);
function isAccountingContractLiabilityAccountType(type) {
    const compact = compactAccountingAccountType(type);
    return compact.length > 0 && CONTRACT_LIABILITY_ACCOUNT_TYPES.has(compact);
}
